import { render } from "./salePerson.vue?vue&type=template&id=6d9c8a7a&scoped=true"
import script from "./salePerson.vue?vue&type=script&lang=js"
export * from "./salePerson.vue?vue&type=script&lang=js"

import "./salePerson.vue?vue&type=style&index=0&id=6d9c8a7a&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9c8a7a"]])

export default __exports__